import { ClassificationFilters } from "@radarly/models/filters";

export const getLevelFilters = (
  filters: ClassificationFilters,
  currentFilter: string,
  level: number
) => {
  const allLevelFilters = filters[level];
  if (level === 1) return allLevelFilters;
  if (level === 2) {
    const root = currentFilter.split("/")[0];
    return allLevelFilters.filter((filter) => filter.parent === root);
  }
  return allLevelFilters.filter((filter) => filter.parent === currentFilter);
};

export const isSelected = (
  filterId: string,
  currentFilter: string,
  level: number
) => {
  if (level === 1) return currentFilter.includes(filterId);
  if (level === 2) return filterId === currentFilter;
  return false;
};

export const getLevelsListFromFilters = (
  classificationFilters: ClassificationFilters
): number[] => Object.keys(classificationFilters).map((key) => Number(key));
